export enum LinkingListType {
	INDEX = "INDEX",
	TO_LINK = "TO_LINK",
	PRODUCT = "PRODUCT",
	CONTACT = "CONTACT",
	STOCK = "STOCK",
	PRODUCT_APP_LINK = "PRODUCT_APP_LINK",
}
